import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { creditCardItemRepository } from '@webapp/modules/accounts-payable/data-access/repositories/CreditCardItemRepository'
import { CreditCardItem } from '@webapp/modules/accounts-payable/entities/CreditCardItem'
import { CREDIT_CARD_ITEM_UNMATCHED_BASE_KEY } from '@webapp/modules/accounts-payable/query-configs/creditCardItemQueries'
import { STATEMENT_ITEM_UNMATCHED_BASE_KEY } from '@webapp/modules/accounts-payable/query-configs/statementItemQueries'

interface InlineEditCreditCardItemVariables {
  id: number
  totalCost: string
  currencyId: number
}

export const useMutateInlineEditCreditCardItem = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<
    CreditCardItem,
    RepoError,
    InlineEditCreditCardItemVariables
  >({
    mutationFn: async ({ id, totalCost, currencyId }) =>
      new CreditCardItem(
        await creditCardItemRepository.updateCostAndCurrency(id, {
          totalCost,
          currencyId,
        })
      ),
    onSuccess: () => {
      // Both panes refetch — suggested matches depend on the cost (BHV-038).
      queryClient.invalidateQueries({
        queryKey: CREDIT_CARD_ITEM_UNMATCHED_BASE_KEY,
      })
      queryClient.invalidateQueries({
        queryKey: STATEMENT_ITEM_UNMATCHED_BASE_KEY,
      })
    },
  })

  return {
    updateCostAndCurrency: mutation.mutateAsync,
    isUpdating: mutation.isLoading,
    error: mutation.error,
  }
}
